import script from "./OrderCreate.vue?vue&type=script&lang=ts&setup=true"
export * from "./OrderCreate.vue?vue&type=script&lang=ts&setup=true"

import "./OrderCreate.vue?vue&type=style&index=0&id=7aa12a63&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7aa12a63"]])

export default __exports__